module.exports = __webpack_public_path__ + "img/watch.9129189c.webp";